import {
  IPAddressLabel,
  Y1564ConfigFieldMapping as ConfigFieldMapping,
  ETHER_TYPE_LABEL,
  FRAME_LOSS_TYPE,
  IPAddressValue,
  TRANSMIT_INTERFACE_VALUE,
  frameLossIntervalValue,
  streamRateConventionValue,
  vlanConfigValue,
  JMEP_STREAM,
  MAP_STREAM,
  QT_STREAM,
  DEFAULT_STREAM,
  definedAddressValue,
  BIDirectional_VTA_STREAM,
  AGENT_AGENT_STREAM,
  LOOPBACK_VTA_STREAM,
  sourceAddressFrom
} from '../models/models';
import { AGENT_MODEL, TestMode, TestLayerValue, TestTypeValue } from '@nrwl/common-lib';
export const Y1564_AGENT_MODEL_CONFIG = {
  id: 'y1564_test',
  agentConfig: {
    default: {
      setup: {
        //setup page model
        alias: {
          enabled: true,
          value: 'Y1564',
          outputField: ConfigFieldMapping.ALIAS,
          tabId: 'y1564_setup',
          restoreOnAgentChange: true
        },
        customer: {
          enabled: true,
          value: '',
          outputField: 'customer',
          tabId: 'y1564_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        contact: {
          enabled: true,
          value: '',
          outputField: 'contact',
          tabId: 'y1564_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        email: {
          enabled: true,
          value: '',
          outputField: 'email',
          tabId: 'y1564_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        phone: {
          enabled: true,
          value: '',
          outputField: 'phone',
          tabId: 'y1564_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technicianId: {
          enabled: true,
          value: '',
          outputField: 'technicianId',
          tabId: 'y1564_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        comments: {
          enabled: true,
          value: '',
          outputField: 'comments',
          tabId: 'y1564_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technician: {
          enabled: true,
          value: '',
          outputField: 'technician',
          tabId: 'y1564_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        testMode: {
          enabled: true,
          value: TestMode.LOOPBACK,
          outputField: ConfigFieldMapping.TEST_MODE,
          tabId: 'y1564_setup',
          restoreOnAgentChange: true
        },
        agentTypeSetup: {
          enabled: true,
          value: 'default',
          outputField: ConfigFieldMapping.AGENT_TYPE,
          tabId: 'y1564_setup',
          restoreOnAgentChange: true
        },
        layerToTest: {
          enabled: true,
          value: TestLayerValue.L2,
          outputField: ConfigFieldMapping.LAYER_TO_TEST,
          tabId: 'y1564_setup',
          restoreOnAgentChange: true
        },
        ipAddressType: {
          enabled: true,
          value: IPAddressValue.IP_V4,
          outputField: ConfigFieldMapping.IP_ADDRESS_TYPE,
          options: {
            type: 'dropdown',
            value: [{ name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 }]
          },
          tabId: 'y1564_setup'
        },
        numberOfSteps: {
          enabled: true,
          value: 4,
          outputField: ConfigFieldMapping.NUMBER_OF_STEPS,
          tabId: 'y1564_setup'
        },
        streamRateConvention: {
          enabled: true,
          value: streamRateConventionValue.L2,
          outputField: ConfigFieldMapping.STREAM_RATE_CONVENTION,
          tabId: 'y1564_setup',
          restoreOnAgentChange: true
        },
        reverseSteps: {
          enabled: false,
          value: false,
          outputField: ConfigFieldMapping.REVERSE_STEPS,
          tabId: 'y1564_setup'
        },
        stepDuration: {
          enabled: true,
          value: 10,
          outputField: ConfigFieldMapping.STEP_DURATION,
          tabId: 'y1564_setup',
          restoreOnAgentChange: true
        },
        perfTestDuration: {
          enabled: true,
          value: 900,
          outputField: ConfigFieldMapping.PERF_TEST_DURATION,
          tabId: 'y1564_setup',
          restoreOnAgentChange: true
        },
        customPerfTestDuration: {
          enabled: true,
          value: '00:15:00',
          outputField: ConfigFieldMapping.PERF_TEST_CUSTOM_DURATION,
          tabId: 'y1564_setup',
          restoreOnAgentChange: true
        },
        testType: {
          enabled: true,
          value: TestTypeValue.Y1564,
          outputField: 'testType',
          tabId: 'y1564_setup'
        },
        runType: {
          enabled: true,
          value: 'on-going',
          outputField: ConfigFieldMapping.RUN_TYPE,
          tabId: 'y1564_setup'
        },
        scheduler: {
          enabled: true,
          value: { repeatInterval: 0, timeStamp: '', endTime: 90, isValid: true },
          outputField: ConfigFieldMapping.SCHEDULER,
          tabId: 'y1564_setup',
          restoreOnAgentChange: true
        },
        runPerfTest: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.RUN_PERF_TEST,
          tabId: 'y1564_setup',
          restoreOnAgentChange: true
        },
        runConfTest: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.RUN_CONFIG_TEST,
          tabId: 'y1564_setup',
          restoreOnAgentChange: true
        },
        stepPercent: {
          enabled: true,
          value: ['25', '50', '75'],
          outputField: ConfigFieldMapping.STEP_PERCENTS,
          tabId: 'y1564_setup',
          restoreOnAgentChange: true,
          outputOptional: true
        },
        abortOnFailure: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.ABORT_ON_FAILURE,
          tabId: 'y1564_setup'
        },
        //endpoints
        agentType: {
          enabled: true,
          value: 'default',
          outputField: ConfigFieldMapping.AGENT_TYPE,
          tabId: 'y1564_endpoints',
          restoreOnAgentChange: true
        },
        engineAInfo: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.ENGINE_A_INFO,
          tabId: 'y1564_endpoints',
          restoreOnAgentChange: true
        },
        engineBInfo: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.ENGINE_B_INFO,
          tabId: 'y1564_endpoints',
          restoreOnAgentChange: true
        },
        selectedOriginator: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SELECTED_ORIGINATOR,
          tabId: 'y1564_endpoints',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        selectedDestination: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SELECTED_DESTINATION,
          tabId: 'y1564_endpoints',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        frameLossInterval: {
          enabled: false,
          value: frameLossIntervalValue.peak,
          outputField: ConfigFieldMapping.FRAME_LOSS_INTERVAL,
          options: {
            type: 'dropdown',
            value: FRAME_LOSS_TYPE
          },
          tabId: 'y1564_endpoints'
        },
        definedAddress: {
          enabled: false,
          value: definedAddressValue.TEST_IP,
          outputField: ConfigFieldMapping.DEFINED_ADDRESS,
          tabId: 'y1564_endpoints'
        },
        sourceAddressFrom: {
          enabled: false,
          value: sourceAddressFrom.MANUAL,
          outputField: ConfigFieldMapping.SOURCE_ADDRESS_FROM,
          tabId: 'y1564_endpoints'
        },
        suppressLoopCommands: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.SUPPRESS_LOOP_COMMANDS,
          tabId: 'y1564_endpoints'
        },
        swapMacAddress: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.SWAP_MAC_ADDRESS,
          tabId: 'y1564_endpoints'
        },
        sendPrimingPackets: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.SEND_PRIMING_PACKETS,
          tabId: 'y1564_endpoints'
        },
        vlanConfig: {
          enabled: true,
          value: vlanConfigValue.UNTAGGED,
          outputField: ConfigFieldMapping.VLAN_CONFIG,
          tabId: 'y1564_endpoints'
        },
        etherType: {
          enabled: true,
          value: ETHER_TYPE_LABEL.ETHER_8100,
          outputField: ConfigFieldMapping.ETHER_TYPE,
          options: {
            type: 'dropdown',
            value: [
              { name: ETHER_TYPE_LABEL.ETHER_8100, value: ETHER_TYPE_LABEL.ETHER_8100 },
              { name: ETHER_TYPE_LABEL.ETHER_88a8, value: ETHER_TYPE_LABEL.ETHER_88a8 }
            ]
          },
          tabId: 'y1564_endpoints'
        },
        deiEnable: {
          enabled: false,
          value: false,
          outputField: ConfigFieldMapping.DEI_ENABLE,
          tabId: 'y1564_endpoints'
        },
        cvlanEthertype: {
          enabled: false,
          value: ETHER_TYPE_LABEL.ETHER_8100,
          outputField: ConfigFieldMapping.CVLAN_ETHER_TYPE,
          tabId: 'y1564_endpoints'
        },
        vlanId: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SVLAN_ID,
          tabId: 'y1564_endpoints',
          outputOptional: true
        },
        cvlanId: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.CVLAN_ID,
          tabId: 'y1564_endpoints',
          outputOptional: true
        },
        verifyVlanPriority: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.VERIFY_PRIORITY,
          tabId: 'y1564_endpoints'
        },
        transmitInterface: {
          enabled: false,
          value: TRANSMIT_INTERFACE_VALUE.EQUIPMENT,
          outputField: ConfigFieldMapping.TRANSMIT_INTERFACE,
          tabId: 'y1564_endpoints'
        },
        srcEditLayer2IP: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.SRC_EDIT_LAYER_2_IP,
          tabId: 'y1564_endpoints'
        },
        srcEditLayer3IP: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.SRC_EDIT_LAYER_3_IP,
          tabId: 'y1564_endpoints'
        },
        srcEditLayer2MAC: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.SRC_EDIT_LAYER_2_MAC,
          tabId: 'y1564_endpoints'
        },
        srcEditLayer3MAC: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.SRC_EDIT_LAYER_3_MAC,
          tabId: 'y1564_endpoints'
        },
        srcMACAddress: {
          enabled: false,
          value: '00:11:22:33:44:55',
          outputField: ConfigFieldMapping.SRC_MAC_ADDRESS,
          tabId: 'y1564_endpoints'
        },
        srcNetworkMacAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.SRC_NETWORK_MAC,
          lookup: ["capabilities.phy['network-mac']"],
          tabId: 'y1564_endpoints',
          outputOptional: true
        },
        srcEquipmentMacAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.SRC_EQUIPMENT_MAC,
          lookup: ["capabilities.phy['equipment-mac']"],
          tabId: 'y1564_endpoints',
          outputOptional: true
        },

        srcTestIpAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.SRC_TEST_IP_ADDRESS,
          lookup: ["capabilities.phy['test-ip']"],
          tabId: 'y1564_endpoints',
          outputOptional: true
        },
        srcAssignedIpAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.SRC_ASSIGNED_IP_ADDRESS,
          lookup: ["capabilities.phy['assigned-ip']"],
          tabId: 'y1564_endpoints',
          outputOptional: true
        },
        srcIpV4Address: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SRC_IPV4_ADDRESS,
          tabId: 'y1564_endpoints',
          outputOptional: true
        },
        srcIpV6Address: {
          enabled: false,
          value: '2000::280:16ff:fe8a:49f0',
          outputField: ConfigFieldMapping.SRC_IPV6_ADDRESS,
          tabId: 'y1564_endpoints'
        },
        srcSubnet: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.SRC_SUBNET,
          lookup: ['capabilities.phy.subnet'],
          tabId: 'y1564_endpoints',
          outputOptional: true
        },
        srcGateway: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.SRC_GATEWAY,
          lookup: ['capabilities.phy.gateway'],
          tabId: 'y1564_endpoints',
          outputOptional: true
        },
        destTransmitInterface: {
          enabled: true,
          value: TRANSMIT_INTERFACE_VALUE.EQUIPMENT,
          outputField: ConfigFieldMapping.DEST_TRANSMIT_INTERFACE,
          tabId: 'y1564_endpoints'
        },
        destDefinedAddress: {
          enabled: true,
          value: definedAddressValue.TEST_IP,
          outputField: ConfigFieldMapping.DEST_DEFINED_ADDRESS,
          tabId: 'y1564_endpoints',
          restoreOnAgentChange: true
        },
        destEditIP: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.DEST_EDIT_IP,
          tabId: 'y1564_endpoints'
        },
        destEditMAC: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.DEST_EDIT_MAC,
          tabId: 'y1564_endpoints'
        },
        destMacAddress: {
          enabled: true,
          value: '00:AA:BB:CC:DD:EE',
          outputField: ConfigFieldMapping.DESTINATION_MAC,
          lookup: ["capabilities.phy['test-mac-address']"],
          tabId: 'y1564_endpoints'
        },
        destIPV4Address: {
          enabled: true,
          value: '192.168.1.2',
          outputField: ConfigFieldMapping.DEST_IPV4_ADDRESS,
          lookup: ["capabilities.phy['default-test-ip']"],
          tabId: 'y1564_endpoints'
        },
        destIPV6Address: {
          enabled: false,
          value: 'FE80::1',
          outputField: ConfigFieldMapping.DEST_IPV6_ADDRESS,
          lookup: ["capabilities.loopback['ipv6-address']"],
          tabId: 'y1564_endpoints'
        },
        destGateway: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.DEST_GATEWAY,
          lookup: ["capabilities.loopback['default-test-gateway']"],
          tabId: 'y1564_endpoints',
          outputOptional: true
        },
        destSubnet: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.DEST_SUBNET,
          lookup: ["capabilities.loopback['default-test-subnet']"],
          tabId: 'y1564_endpoints',
          outputOptional: true
        },
        remoteVlanTagCount: {
          enabled: false,
          value: 0,
          outputField: ConfigFieldMapping.REMOTE_VLAN_TAG,
          tabId: 'y1564_endpoints'
        },
        destShowIpLayer2: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.DEST_SHOW_IP_LAYER2,
          tabId: 'y1564_endpoints'
        },
        destShowMacLayer3: {
          enabled: false,
          value: false,
          outputField: ConfigFieldMapping.DEST_SHOW_MAC_LAYER3,
          tabId: 'y1564_endpoints'
        },
        useARPtoLearnMac: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.USE_ARP,
          tabId: 'y1564_endpoints'
        },

        //streams models
        deviceSelectionMethod: {
          enabled: false,
          value: 'MAC',
          outputField: ConfigFieldMapping.DEVICE_SELECTION_METHOD,
          tabId: 'y1564_streams'
        },
        frameLength: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.FRAME_LENGTH,
          tabId: 'y1564_streams'
        },
        streams: {
          enabled: true,
          value: DEFAULT_STREAM,
          outputField: ConfigFieldMapping.STREAMS,
          tabId: 'y1564_streams'
        },
        maxServices: {
          enabled: true,
          value: 1,
          outputField: ConfigFieldMapping.MAX_SERVICES,
          tabId: 'y1564_streams'
        },
        biDirection: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.BI_DIRECTIONAL,
          tabId: 'y1564_streams'
        },
        maxBandwidth: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.MAX_BANDWIDTH,
          tabId: 'y1564_streams',
          outputOptional: true
        },
        validFrameSizes: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              sctFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false }
              ],
              minValue: 64,
              maxValue: 9000,
              selectedVlans: 0
            },
            ipv6: {
              sctFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false }
              ],
              minValue: 78,
              maxValue: 9000,
              selectedVlans: 0
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE,
          tabId: 'y1564_streams'
        },
        validFrameSizesSingle: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE_SINGLE,
          tabId: 'y1564_streams',
          outputOptional: true
        },
        validFrameSizesDouble: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE_DOUBLE,
          tabId: 'y1564_streams',
          outputOptional: true
        },
        sctFramesSizes: {
          enabled: true,
          value: [512],
          outputField: ConfigFieldMapping.SCT_FRAME_SIZE,
          tabId: 'y1564_streams',
          restoreOnAgentChange: true
        },
        sptFrameSize: {
          enabled: true,
          value: [512],
          outputField: ConfigFieldMapping.SPT_FRAME_SIZE,
          tabId: 'y1564_streams',
          restoreOnAgentChange: true
        }
      },

      running: {
        add: 'anything that is different between agents in running view'
      },

      final: {
        add: 'anything that is different between agents in final report'
      }
    },

    [AGENT_MODEL.JMEP_1G]: {
      setup: {
        ipAddressType: {
          enabled: true,
          options: {
            type: 'dropdown',
            value: [
              { name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 },
              { name: IPAddressLabel.IP_V6, value: IPAddressValue.IP_V6 }
            ]
          }
        },
        frameLossInterval: {
          enabled: true
        },
        swapMacAddress: {
          enabled: true
        },
        sendPrimingPackets: {
          enabled: true
        },
        maxBandwidth: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.MAX_BANDWIDTH,
          lookup: ["capabilities['y1564']['max-bandwidth']"],
          tabId: 'y1564_streams',
          outputOptional: true
        },
        reverseSteps: { enabled: true },
        vlanDefinedForEachService: { enabled: false },
        etherTypeDefinedForEachService: { enabled: false },
        vlanId: {
          enabled: true,
          lookup: ["capabilities.phy['test-vlan-id']"]
        },
        cvlanEthertype: { enabled: true },
        transmitInterface: { enabled: true },
        definedAddress: { enabled: true },
        srcEditLayer2IP: { enabled: true },
        srcEditLayer3IP: { enabled: true },
        srcEditLayer2MAC: { enabled: false },
        srcEditLayer3MAC: { enabled: false },
        srcMACAddress: { enabled: false },
        srcNetworkMacAddress: { enabled: true },
        srcEquipmentMacAddress: { enabled: true },
        srcTestIpAddress: { enabled: true },
        srcAssignedIpAddress: { enabled: true },
        srcIpV6Address: { enabled: true },
        srcSubnet: { enabled: true },
        srcGateway: { enabled: true },
        remoteVlanTagCount: { enabled: true },
        destIPV6Address: { enabled: true },
        destShowIpLayer2: { enabled: true },
        destShowMacLayer3: { enabled: true },
        useARPtoLearnMac: { enabled: true },
        maxServices: {
          enabled: true,
          value: 4
        },
        svlanPriority: { enabled: true },
        cvlanPriority: { enabled: true },
        verifyVlanPriority: { enabled: true },
        errorOnOOS: { enabled: true },
        trafficClass: { enabled: true },
        hopLimit: { enabled: true },
        overheadBytes: { enabled: true },
        validFrameSizes: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: true,
            ipv4: {
              sctFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false },
                { label: 'EMIX', value: ['512', '1518'], enable: false }
              ],
              sptFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false },
                { label: 'EMIX', value: ['512', '1518'], enable: false }
              ],
              minValue: 64,
              maxValue: 9000,
              selectedVlans: 0
            },
            ipv6: {
              sctFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false },
                { label: 'EMIX', value: ['512', '1518'], enable: false }
              ],
              sptFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false },
                { label: 'EMIX', value: ['512', '1518'], enable: false }
              ],
              minValue: 78,
              maxValue: 9000,
              selectedVlans: 0
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE,
          tabId: 'y1564_streams'
        },
        streams: {
          enabled: true,
          value: JMEP_STREAM,
          outputField: ConfigFieldMapping.STREAMS,
          tabId: 'y1564_streams'
        }
      },
      versions: {
        /* if vta has newer versions then the differences can be put here */
        '2.0': {
          setup: {},
          running: {},
          final: {}
        }
      },
      modes: {
        [TestMode.LOOPBACK]: {
          setup: {
            suppressLoopCommands: { enabled: true },
            engineBInfo: { enabled: false }
          }
        }
      }
    },

    [AGENT_MODEL.JMEP_10G]: {
      setup: {
        ipAddressType: {
          enabled: true,
          options: {
            type: 'dropdown',
            value: [
              { name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 },
              { name: IPAddressLabel.IP_V6, value: IPAddressValue.IP_V6 }
            ]
          }
        },
        frameLossInterval: {
          enabled: true
        },
        swapMacAddress: {
          enabled: true
        },
        sendPrimingPackets: {
          enabled: true
        },
        maxBandwidth: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.MAX_BANDWIDTH,
          lookup: ["capabilities['y1564']['max-bandwidth']"],
          tabId: 'y1564_streams',
          outputOptional: true
        },
        reverseSteps: { enabled: true },
        vlanId: {
          enabled: true,
          lookup: ["capabilities.phy['test-vlan-id']"]
        },
        vlanDefinedForEachService: { enabled: false },
        etherTypeDefinedForEachService: { enabled: false },
        cvlanEthertype: { enabled: true },
        transmitInterface: { enabled: true },
        definedAddress: { enabled: true },
        srcEditLayer2IP: { enabled: true },
        srcEditLayer3IP: { enabled: true },
        srcEditLayer2MAC: { enabled: false },
        srcEditLayer3MAC: { enabled: false },
        srcNetworkMacAddress: { enabled: true },
        srcEquipmentMacAddress: { enabled: true },
        srcMACAddress: { enabled: false },
        srcTestIpAddress: { enabled: true },
        srcAssignedIpAddress: { enabled: true },
        srcIpV6Address: { enabled: true },
        srcSubnet: { enabled: true },
        srcGateway: { enabled: true },
        destIPV6Address: { enabled: true },
        remoteVlanTagCount: { enabled: true },
        destShowIpLayer2: { enabled: true },
        destShowMacLayer3: { enabled: true },
        useARPtoLearnMac: { enabled: true },
        maxServices: {
          enabled: true,
          value: 4
        },
        svlanPriority: { enabled: true },
        cvlanPriority: { enabled: true },
        verifyVlanPriority: { enabled: true },
        errorOnOOS: { enabled: true },
        trafficClass: { enabled: true },
        hopLimit: { enabled: true },
        overheadBytes: { enabled: true },
        validFrameSizes: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: true,
            ipv4: {
              sctFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false },
                { label: 'EMIX', value: ['512', '1518'], enable: false }
              ],
              sptFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false },
                { label: 'EMIX', value: ['512', '1518'], enable: false }
              ],
              minValue: 64,
              maxValue: 9000,
              selectedVlans: 0
            },
            ipv6: {
              sctFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false },
                { label: 'EMIX', value: ['512', '1518'], enable: false }
              ],
              sptFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false },
                { label: 'EMIX', value: ['512', '1518'], enable: false }
              ],
              minValue: 78,
              maxValue: 9000,
              selectedVlans: 0
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE,
          tabId: 'y1564_streams'
        },
        streams: {
          enabled: true,
          value: JMEP_STREAM,
          outputField: ConfigFieldMapping.STREAMS,
          tabId: 'y1564_streams'
        }
      },
      versions: {
        /* if vta has newer versions then the differences can be put here */
        '2.0': {
          setup: {},
          running: {},
          final: {}
        }
      },
      modes: {
        [TestMode.LOOPBACK]: {
          setup: {
            suppressLoopCommands: { enabled: true },
            engineBInfo: { enabled: false }
          }
        }
      }
    },

    [AGENT_MODEL.QT600]: {
      setup: {
        ipAddressType: {
          enabled: true,
          options: {
            type: 'dropdown',
            value: [
              { name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 },
              { name: IPAddressLabel.IP_V6, value: IPAddressValue.IP_V6 }
            ]
          }
        },
        frameLossInterval: {
          enabled: true
        },
        reverseSteps: { enabled: true },
        srcEditLayer2IP: { enabled: true },
        srcEditLayer3IP: { enabled: true },
        srcEditLayer2MAC: { enabled: true },
        srcEditLayer3MAC: { enabled: true },
        srcMACAddress: { enabled: true },
        maxBandwidth: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.MAX_BANDWIDTH,
          lookup: ["capabilities['y1564-list'][{index}]['max-bandwidth']"],
          tabId: 'y1564_streams',
          outputOptional: true
        },
        srcTestIpAddress: {
          enabled: true,
          lookup: ["capabilities['phy-list'][{index}]['default-test-ip']"]
        },
        srcIpV6Address: { enabled: true },
        srcSubnet: {
          enabled: true,
          lookup: ["capabilities['phy-list'][{index}]['default-test-mask']"]
        },
        srcGateway: {
          enabled: true,
          lookup: ["capabilities['phy-list'][{index}]['default-test-gateway']"]
        },
        sourceAddressFrom: { enabled: true },
        remoteVlanTagCount: { enabled: true },
        destIPV6Address: { enabled: true },
        destShowIpLayer2: { enabled: true },
        destShowMacLayer3: { enabled: true },
        useARPtoLearnMac: { enabled: true },

        maxServices: {
          enabled: true,
          value: 10
        },
        etherType: {
          options: {
            type: 'dropdown',
            value: [
              { name: ETHER_TYPE_LABEL.ETHER_8100, value: ETHER_TYPE_LABEL.ETHER_8100 },
              { name: ETHER_TYPE_LABEL.ETHER_88a8, value: ETHER_TYPE_LABEL.ETHER_88a8 },
              { name: ETHER_TYPE_LABEL.ETHER_9100, value: ETHER_TYPE_LABEL.ETHER_9100 }
            ]
          }
        },
        cbs: { enabled: true },
        kbSize: { enabled: true },
        cbsRepetitions: { enabled: true },
        cbsLineRate: { enabled: true },
        validFrameSizes: {
          enabled: true,
          value: {
            multiSelectFrames: true,
            emixFrames: true,
            ipv4: {
              sctFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false },
                { label: 'EMIX', value: ['512', '1518'], enable: false }
              ],
              sptFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false },
                { label: 'EMIX', value: ['512', '1518'], enable: false }
              ],
              minValue: 64,
              maxValue: 9000,
              selectedVlans: 0
            },
            ipv6: {
              sctFrameList: [
                //   { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false },
                { label: 'EMIX', value: ['512', '1518'], enable: false }
              ],
              sptFrameList: [
                // { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false },
                { label: 'EMIX', value: ['512', '1518'], enable: false }
              ],
              minValue: 78,
              maxValue: 9000,
              selectedVlans: 0
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE,
          tabId: 'y1564_streams'
        },

        sctFramesSizes: { enabled: true },
        svlanPriority: { enabled: true },
        cvlanPriority: { enabled: true },
        errorOnOOS: { enabled: true },
        dscp: { enabled: true, value: 46 },
        ttl: { enabled: true },
        trafficClass: { enabled: true },
        hopLimit: { enabled: true },
        streams: {
          enabled: true,
          value: QT_STREAM,
          outputField: ConfigFieldMapping.STREAMS,
          tabId: 'y1564_streams'
        }
      },
      versions: {
        /* if vta has newer versions then the differences can be put here */
        '2.0': {
          setup: {},
          running: {},
          final: {}
        }
      },
      modes: {
        [TestMode.LOOPBACK]: {
          setup: {
            suppressLoopCommands: { enabled: true },
            engineBInfo: { enabled: false }
          }
        }
      }
    },

    [AGENT_MODEL.MAP2100]: {
      setup: {
        ipAddressType: {
          enabled: true,
          options: {
            type: 'dropdown',
            value: [{ name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 }]
          }
        },
        vlanDefinedForEachService: { enabled: true },
        etherTypeDefinedForEachService: { enabled: true },
        srcEditLayer2IP: { enabled: false },
        srcEditLayer3IP: { enabled: true },
        srcEditLayer2MAC: { enabled: false },
        srcEditLayer3MAC: { enabled: true },
        maxBandwidth: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.MAX_BANDWIDTH,
          lookup: ["capabilities['y1564-list'][{index}]['max-bandwidth']"],
          tabId: 'y1564_streams',
          outputOptional: true
        },
        srcTestIpAddress: {
          enabled: true,
          lookup: ["capabilities['phy-list'][{index}]['default-test-ip']"]
        },
        srcSubnet: {
          enabled: true,
          lookup: ["capabilities['phy-list'][{index}]['default-test-mask']"]
        },
        srcGateway: {
          enabled: true,
          lookup: ["capabilities['phy-list'][{index}]['default-test-gateway']"]
        },
        etherType: {
          options: {
            type: 'dropdown',
            value: [
              { name: ETHER_TYPE_LABEL.ETHER_8100, value: ETHER_TYPE_LABEL.ETHER_8100 },
              { name: ETHER_TYPE_LABEL.ETHER_88a8, value: ETHER_TYPE_LABEL.ETHER_88a8 },
              { name: ETHER_TYPE_LABEL.ETHER_9100, value: ETHER_TYPE_LABEL.ETHER_9100 }
            ]
          }
        },
        deiEnable: { enabled: true },
        maxServices: {
          enabled: true,
          value: 10
        },
        fd: { enabled: true },
        validFrameSizes: {
          enabled: true,
          value: {
            multiSelectFrames: true,
            emixFrames: false,
            ipv4: {
              sctFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false }
              ],
              minValue: 64,
              maxValue: 9000,
              selectedVlans: 0
            },
            ipv6: {
              sctFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false }
              ],
              minValue: 78,
              maxValue: 9000,
              selectedVlans: 0
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE,
          tabId: 'y1564_streams'
        },
        validFrameSizesSingle: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              sctFrameList: [
                { label: 68, value: 68, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1522, value: 1522, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 68, value: 68, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1522, value: 1522, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              minValue: 68,
              maxValue: 9000,
              selectedVlans: 0
            },
            ipv6: {
              sctFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              minValue: 78,
              maxValue: 9000,
              selectedVlans: 0
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE_SINGLE,
          tabId: 'y1564_streams'
        },
        validFrameSizesDouble: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              sctFrameList: [
                { label: 72, value: 72, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1526, value: 1526, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 72, value: 72, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1526, value: 1526, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              minValue: 72,
              maxValue: 9000,
              selectedVlans: 0
            },
            ipv6: {
              sctFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              minValue: 78,
              maxValue: 9000,
              selectedVlans: 0
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE_DOUBLE,
          tabId: 'y1564_streams'
        },
        sctFramesSizes: { enabled: true },
        ttl: { enabled: true },
        streams: {
          enabled: true,
          value: MAP_STREAM,
          outputField: ConfigFieldMapping.STREAMS,
          tabId: 'y1564_streams'
        }
      },
      versions: {
        /* if vta has newer versions then the differences can be put here */
        '2.0': {
          setup: {},
          running: {},
          final: {}
        }
      },
      modes: {
        [TestMode.LOOPBACK]: {
          setup: {
            suppressLoopCommands: { enabled: true },
            engineBInfo: { enabled: false }
          }
        }
      }
    },

    [AGENT_MODEL.VTA]: {
      setup: {
        ipAddressType: {
          enabled: true,
          options: {
            type: 'dropdown',
            value: [{ name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 }]
          }
        },
        vlanConfig: { enabled: false },
        srcEditLayer2IP: { enabled: false },
        srcEditLayer3IP: { enabled: true },
        srcEditLayer2MAC: { enabled: false },
        srcEditLayer3MAC: { enabled: false },
        srcMACAddress: { enabled: true, lookup: ["capabilities.phy['test-mac-address']"] },
        srcTestIpAddress: { enabled: true, lookup: ["capabilities.phy['default-test-ip']"] },
        srcSubnet: { enabled: true, lookup: ["capabilities.phy['default-test-mask']"] },
        srcGateway: {
          enabled: true,
          lookup: ["capabilities.phy['default-test-gateway']"]
        },
        maxBandwidth: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.MAX_BANDWIDTH,
          lookup: ["capabilities['y1564']['max-bandwidth']"],
          tabId: 'y1564_streams',
          outputOptional: true
        },
        destMacAddress: { enabled: true, lookup: ["capabilities.phy['test-mac-address']"] },
        destIPV4Address: { lookup: ["capabilities.phy['default-test-ip']"] },
        destGateway: { enabled: true, lookup: ["capabilities.phy['default-test-gateway']"] },
        destSubnet: { enabled: true, lookup: ["capabilities.phy['default-test-mask']"] },
        etherType: {
          options: {
            type: 'dropdown',
            value: [
              { name: ETHER_TYPE_LABEL.ETHER_8100, value: ETHER_TYPE_LABEL.ETHER_8100 },
              { name: ETHER_TYPE_LABEL.ETHER_88a8, value: ETHER_TYPE_LABEL.ETHER_88a8 },
              { name: ETHER_TYPE_LABEL.ETHER_9100, value: ETHER_TYPE_LABEL.ETHER_9100 }
            ]
          }
        },
        maxServices: {
          enabled: true,
          value: 10
        },
        fd: { enabled: false },
        fdv: { enabled: false },
        validFrameSizes: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              sctFrameList: [
                { label: 66, value: 66, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 66, value: 66, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false }
              ],
              minValue: 66,
              maxValue: 9000,
              selectedVlans: 0
            },
            ipv6: {
              sctFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false }
              ],
              minValue: 78,
              maxValue: 9000,
              selectedVlans: 0
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE,
          tabId: 'y1564_streams'
        },
        ttl: { enabled: true, value: 32 },
        payload: { enabled: true },
        abortOnFailure: { enabled: true },
        streams: {
          enabled: true,
          value: AGENT_AGENT_STREAM,
          outputField: ConfigFieldMapping.STREAMS,
          tabId: 'y1564_streams'
        },
        deviceSelectionMethod: { enabled: true },
        frameLength: { enabled: true }
      },
      versions: {
        /* if vta has newer versions then the differences can be put here */
        '2.0': {
          setup: {},
          running: {},
          final: {}
        }
      },
      modes: {
        [TestMode.LOOPBACK]: {
          setup: {
            streams: { value: LOOPBACK_VTA_STREAM },
            destGateway: { enabled: false },
            destSubnet: { enabled: false },
            suppressLoopCommands: { enabled: true },
            engineBInfo: { enabled: false }
          }
        },
        [TestMode.UNIDIRECIONAL]: {
          setup: {
            streams: { value: AGENT_AGENT_STREAM }
          }
        },
        [TestMode.SEQUENTIAL]: {
          setup: {
            streams: { value: BIDirectional_VTA_STREAM },
            biDirection: { enabled: true }
          }
        },
        [TestMode.CONCURRENT]: {
          setup: {
            streams: { value: BIDirectional_VTA_STREAM },
            biDirection: { enabled: true }
          }
        }
      }
    },

    [AGENT_MODEL.VSPA_SAT]: {
      setup: {
        ipAddressType: {
          enabled: true,
          options: {
            type: 'dropdown',
            value: [{ name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 }]
          }
        },
        vlanConfig: { enabled: false },
        srcEditLayer2IP: { enabled: false },
        srcEditLayer3IP: { enabled: true },
        srcEditLayer2MAC: { enabled: false },
        srcEditLayer3MAC: { enabled: false },
        srcMACAddress: { enabled: true, lookup: ["capabilities.phy['test-mac-address']"] },
        srcTestIpAddress: { enabled: true, lookup: ["capabilities.phy['default-test-ip']"] },
        srcSubnet: { enabled: true, lookup: ["capabilities.phy['default-test-mask']"] },
        srcGateway: {
          enabled: true,
          lookup: ["capabilities.phy['default-test-gateway']"]
        },
        maxBandwidth: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.MAX_BANDWIDTH,
          lookup: ["capabilities['y1564']['max-bandwidth']"],
          tabId: 'y1564_streams',
          outputOptional: true
        },
        destMacAddress: { enabled: true, lookup: ["capabilities.phy['test-mac-address']"] },
        destIPV4Address: { lookup: ["capabilities.phy['default-test-ip']"] },
        destGateway: { enabled: true, lookup: ["capabilities.phy['default-test-gateway']"] },
        destSubnet: { enabled: true, lookup: ["capabilities.phy['default-test-mask']"] },
        etherType: {
          options: {
            type: 'dropdown',
            value: [
              { name: ETHER_TYPE_LABEL.ETHER_8100, value: ETHER_TYPE_LABEL.ETHER_8100 },
              { name: ETHER_TYPE_LABEL.ETHER_88a8, value: ETHER_TYPE_LABEL.ETHER_88a8 },
              { name: ETHER_TYPE_LABEL.ETHER_9100, value: ETHER_TYPE_LABEL.ETHER_9100 }
            ]
          }
        },
        maxServices: {
          enabled: true,
          value: 10
        },
        fd: { enabled: false },
        fdv: { enabled: false },
        validFrameSizes: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              sctFrameList: [
                { label: 66, value: 66, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 66, value: 66, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false }
              ],
              minValue: 66,
              maxValue: 9000,
              selectedVlans: 0
            },
            ipv6: {
              sctFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false }
              ],
              minValue: 78,
              maxValue: 9000,
              selectedVlans: 0
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE,
          tabId: 'y1564_streams'
        },
        ttl: { enabled: true, value: 32 },
        payload: { enabled: true },
        abortOnFailure: { enabled: true },
        streams: {
          enabled: true,
          value: AGENT_AGENT_STREAM,
          outputField: ConfigFieldMapping.STREAMS,
          tabId: 'y1564_streams'
        },
        deviceSelectionMethod: { enabled: true },
        frameLength: { enabled: true }
      },
      versions: {
        /* if vta has newer versions then the differences can be put here */
        '2.0': {
          setup: {},
          running: {},
          final: {}
        }
      },
      modes: {
        [TestMode.LOOPBACK]: {
          setup: {
            streams: { value: LOOPBACK_VTA_STREAM },
            destGateway: { enabled: false },
            destSubnet: { enabled: false },
            suppressLoopCommands: { enabled: true },
            engineBInfo: { enabled: false }
          }
        },
        [TestMode.SEQUENTIAL]: {
          setup: {
            streams: { value: BIDirectional_VTA_STREAM },
            biDirection: { enabled: true }
          }
        },
        [TestMode.CONCURRENT]: {
          setup: {
            streams: { value: BIDirectional_VTA_STREAM },
            biDirection: { enabled: true }
          }
        }
      }
    },

    [AGENT_MODEL.MTS]: {
      setup: {
        ipAddressType: {
          enabled: true,
          options: {
            type: 'dropdown',
            value: [{ name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 }]
          }
        },
        srcEditLayer2IP: { enabled: false },
        srcEditLayer3IP: { enabled: true },
        srcEditLayer2MAC: { enabled: false },
        srcEditLayer3MAC: { enabled: false },
        srcMACAddress: { enabled: true, lookup: ["capabilities.phy['test-mac-address']"] },
        srcTestIpAddress: { enabled: true, lookup: ["capabilities.phy['default-test-ip']"] },
        srcSubnet: { enabled: true, lookup: ["capabilities.phy['default-test-mask']"] },
        srcGateway: {
          enabled: true,
          lookup: ["capabilities.phy['default-test-gateway']"]
        },
        maxBandwidth: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.MAX_BANDWIDTH,
          lookup: ["capabilities['y1564']['max-bandwidth']"],
          tabId: 'y1564_streams',
          outputOptional: true
        },
        destMacAddress: { enabled: true, lookup: ["capabilities.phy['test-mac-address']"] },
        destIPV4Address: { lookup: ["capabilities.phy['default-test-ip']"] },
        destGateway: { enabled: true, lookup: ["capabilities.phy['default-test-gateway']"] },
        destSubnet: { enabled: true, lookup: ["capabilities.phy['default-test-mask']"] },
        etherType: {
          options: {
            type: 'dropdown',
            value: [
              { name: ETHER_TYPE_LABEL.ETHER_8100, value: ETHER_TYPE_LABEL.ETHER_8100 },
              { name: ETHER_TYPE_LABEL.ETHER_88a8, value: ETHER_TYPE_LABEL.ETHER_88a8 },
              { name: ETHER_TYPE_LABEL.ETHER_9100, value: ETHER_TYPE_LABEL.ETHER_9100 }
            ]
          }
        },
        maxServices: {
          enabled: true,
          value: 9
        },
        fd: { enabled: false },
        fdv: { enabled: false },
        validFrameSizes: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              sctFrameList: [
                { label: 66, value: 66, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 66, value: 66, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false }
              ],
              minValue: 66,
              maxValue: 9000,
              selectedVlans: 0
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE,
          tabId: 'y1564_streams'
        },
        validFrameSizesSingle: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              sctFrameList: [
                { label: 70, value: 70, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1522, value: 1522, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 70, value: 70, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1522, value: 1522, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],

              minValue: 70,
              maxValue: 9000,
              selectedVlans: 0
            },
            ipv6: {
              sctFrameList: [
                { label: 74, value: 74, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 74, value: 74, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],

              minValue: 74,
              maxValue: 9000,
              selectedVlans: 0
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE_SINGLE,
          tabId: 'y1564_streams'
        },
        validFrameSizesDouble: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              sctFrameList: [
                { label: 74, value: 74, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1526, value: 1526, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 74, value: 74, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1526, value: 1526, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],

              minValue: 74,
              maxValue: 9000,
              selectedVlans: 0
            },
            ipv6: {
              sctFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              sptFrameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],

              minValue: 78,
              maxValue: 9000,
              selectedVlans: 0
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE_DOUBLE,
          tabId: 'y1564_streams'
        },
        ttl: { enabled: true, value: 32 },
        payload: { enabled: true },
        abortOnFailure: { enabled: true },
        streams: {
          enabled: true,
          value: AGENT_AGENT_STREAM,
          outputField: ConfigFieldMapping.STREAMS,
          tabId: 'y1564_streams'
        },
        deviceSelectionMethod: { enabled: true },
        frameLength: { enabled: true },
        layerToTest: {
          value: TestLayerValue.L4
        }
      },
      versions: {
        /* if vta has newer versions then the differences can be put here */
        '2.0': {
          setup: {},
          running: {},
          final: {}
        }
      },
      modes: {
        [TestMode.LOOPBACK]: {
          setup: {
            streams: { value: LOOPBACK_VTA_STREAM },
            suppressLoopCommands: { enabled: true },
            destGateway: { enabled: false },
            destSubnet: { enabled: false },
            engineBInfo: { enabled: false }
          }
        },
        [TestMode.UNIDIRECIONAL]: {
          setup: {
            streams: { value: AGENT_AGENT_STREAM }
          }
        },
        [TestMode.SEQUENTIAL]: {
          setup: {
            streams: { value: BIDirectional_VTA_STREAM },
            biDirection: { enabled: true }
          }
        },
        [TestMode.CONCURRENT]: {
          setup: {
            streams: { value: BIDirectional_VTA_STREAM },
            biDirection: { enabled: true }
          }
        }
      }
    }
  }
};
